import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { closeAllModal, showModal, showNestedModal } from "../../../features/modal/modalSlice"
import Button from "../../shared/Button"
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { deleteBlog } from "../../../features/admin3/admin3Slice"
import Btn from "../../shared/button/Btn"
import SmallSpinner from "../../shared/spinners/SmallSpinner"

const Container = styled.div`

    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        p{
            font-size: 16px;
            font-weight: var(--font-weight-lg);
            color: ${({ theme }) => theme.mainTextColor};
            padding: 10px 60px 40px;
            line-height: 1.4;
            text-align: center;
            
            .red{
              color: var(--color-dark-red);
              font-weight: var(--font-weight-xl);
              font-size: 18px;

            }
        }

        .button-grp{
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 20px;
            width: 100%;
            margin: 20px 0;
        }
    }
`
const AdminDeleteMultiBlogPermissionModal = () => {
  const { modalLocation} = useSelector(state => state.modal)
  const { lockScroll, unlockScroll } = useScrollLock();

    const {selectedBlogs, isLoadingDeleteBlog} = useSelector((state) => state.admin3)
  const dispatch = useDispatch()
  const location = useLocation()

           //! bu modal açıldığnda ekran ı lock lamak için
           useEffect(() => {
            lockScroll()
    
            return () => {
                unlockScroll()
            }
        }, [lockScroll, unlockScroll])
    
        //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
        useEffect(() => {
            if (location.pathname !== modalLocation) {
                dispatch(showModal(null))
            }
        }, [dispatch, location.pathname, modalLocation])

            const handleDeleteBlog = () => {
                dispatch(deleteBlog(selectedBlogs.map(it => it.id)))
            }


  return (
    <Container onClick={()=> dispatch(showModal(null))}>
      <div className="modal" onClick={(e)=> e.stopPropagation() }>
        <p>Seçili Blogları silmek istediğinize emin misiniz? (Bu işlem geri alınamaz)</p>
        <div className="button-grp">
                <Btn width={"200px"} color="#fff" bgColor="#E85446" padding="0 10px" handleClick={handleDeleteBlog} >{isLoadingDeleteBlog ? <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"}/> : "Seçili Blogları Komple Sil"}</Btn>
                <Btn width={"200px"} color="#E85446" bgColor="transparent" padding="0 10px"  handleClick={()=> dispatch(showModal(null))}>Vazgeç</Btn>
            </div>
      </div>
    </Container>
  )
}

export default AdminDeleteMultiBlogPermissionModal